class MaterialIcon extends HTMLElement {
    connectedCallback() {
        const name = this.getAttribute("icon"); // z.B. "call", "mail"
        this.innerHTML = `
            <svg class="wx-icon" aria-hidden="true">
                <use href="#wx-icons-${name}"></use>
            </svg>
        `;
    }
}

customElements.define("custom-icon", MaterialIcon);


window.onload = pageLoaded;
window.addEventListener('hashchange', checkHash);

function pageLoaded() {
    splideSliders();
    checkHash();
    initAosAnimations();
    initMobileNav();
}


function initMobileNav() {
    const toggle = document.querySelector('[data-nav-toggle]');
    const menu = document.querySelector('[data-nav-menu]');
    if (!toggle || !menu) return;

    const setOpen = (open) => {
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        toggle.setAttribute('aria-label', open ? 'Navigation schließen' : 'Navigation öffnen');
        document.body.classList.toggle('nav-open', open);
        if (!open) {
            menu.querySelectorAll('.is-open').forEach((el) => el.classList.remove('is-open'));
        }
    };

    const isOpen = () => toggle.getAttribute('aria-expanded') === 'true';

    toggle.addEventListener('click', (e) => {
        e.stopPropagation();
        setOpen(!isOpen());
    });

    // Submenu-Toggle (Level-2 / Level-3) auf Mobile
    menu.addEventListener('click', (e) => {
        const icon = e.target.closest('.dropdown-icon');
        if (!icon) return;
        const parentLi = icon.closest('.has-dropdown, .has-children');
        if (!parentLi) return;
        e.preventDefault();
        e.stopPropagation();

        const wasOpen = parentLi.classList.contains('is-open');

        // Geschwister auf gleicher Ebene zuklappen
        const siblingScope = parentLi.parentElement;
        if (siblingScope) {
            siblingScope.querySelectorAll(':scope > .has-dropdown.is-open, :scope > .has-children.is-open').forEach((sib) => {
                if (sib !== parentLi) sib.classList.remove('is-open');
            });
        }

        parentLi.classList.toggle('is-open', !wasOpen);
    });

    // Klick auf Menü-Link schließt Drawer
    menu.addEventListener('click', (e) => {
        if (e.target.closest('.dropdown-icon')) return;
        const link = e.target.closest('a');
        if (link) setOpen(false);
    });

    // Klick außerhalb schließt Drawer
    document.addEventListener('click', (e) => {
        if (!isOpen()) return;
        if (toggle.contains(e.target) || menu.contains(e.target)) return;
        setOpen(false);
    });

    // ESC schließt Drawer
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && isOpen()) {
            setOpen(false);
            toggle.focus();
        }
    });

    // Beim Hochskalieren auf Desktop sicher schließen
    const mq = window.matchMedia('(min-width: 992px)');
    const handleResize = (e) => {
        if (e.matches && isOpen()) setOpen(false);
    };
    if (mq.addEventListener) mq.addEventListener('change', handleResize);
    else mq.addListener(handleResize);
}


function initAosAnimations() {
    if(document.querySelector('.ce-textpic.ce-intext')) {
        const intext = document.querySelectorAll('.ce-textpic.ce-intext');

        intext.forEach(element => {
            console.log(element);
            if(element.classList.contains('ce-right')) {
                // Bild rechts
                console.log("Bild rechts");
                if(element.querySelector('.ce-gallery')) {
                    const gallery = element.querySelector('.ce-gallery');
                    gallery.setAttribute('data-aos', 'fade-right');
                }

                if(element.querySelector('.ce-bodytext')) {
                    const bodytext = element.querySelector('.ce-bodytext');
                    bodytext.setAttribute('data-aos', 'fade-left');
                }
            }
            else {
                // Bild links
                console.log("Bild links");
                if(element.querySelector('.ce-gallery')) {
                    const gallery = element.querySelector('.ce-gallery');
                    gallery.setAttribute('data-aos', 'fade-left');
                }

                if(element.querySelector('.ce-bodytext')) {
                    const bodytext = element.querySelector('.ce-bodytext');
                    bodytext.setAttribute('data-aos', 'fade-right');
                }
            }
        });
    }


    AOS.init();
}





function checkHash() {
    if (!window.location.hash) return;

    const hash = window.location.hash.substring(1); // ohne #
    const target = document.querySelector('.' + CSS.escape(hash));
    if (!target) return;

    const nav = document.querySelector('.nav-bar');
    const navHeight = nav ? nav.offsetHeight : 0;

    const targetPosition =
        target.getBoundingClientRect().top +
        window.pageYOffset -
        navHeight;

    window.scrollTo({
        top: targetPosition,
        behavior: 'smooth',
    });
}






function toggleAccordion(headEl) {
    const itemEl = headEl.closest(".accordion-item");
    if (!itemEl) return;

    const listEl = itemEl.closest(".accordion-list");
    if (!listEl) return;

    const contentEl = itemEl.querySelector(".accordion-content");
    if (!contentEl) return;

    const isOpen = itemEl.classList.contains("active");

    // Immer nur eins offen: alle anderen schließen (smooth)
    listEl.querySelectorAll(".accordion-item.active").forEach((openItem) => {
        if (openItem === itemEl) return;
        openItem.classList.remove("active");
        const openContent = openItem.querySelector(".accordion-content");
        if (openContent) collapseSmooth(openContent);
    });

    // aktuelles togglen
    if (isOpen) {
        itemEl.classList.remove("active");
        collapseSmooth(contentEl);
    } else {
        itemEl.classList.add("active");
        expandSmooth(contentEl);
    }
}

function expandSmooth(el) {
    // Falls gerade am Collapsen: Transition resetten
    el.style.transition = "none";

    // Startzustand
    el.style.overflow = "hidden";
    el.style.height = "0px";

    // Reflow + im nächsten Frame animieren
    el.offsetHeight;
    requestAnimationFrame(() => {
        el.style.transition = "height 300ms ease";
        el.style.height = el.scrollHeight + "px";
    });

    const onEnd = (e) => {
        if (e.propertyName !== "height") return;
        el.removeEventListener("transitionend", onEnd);
    };
    el.addEventListener("transitionend", onEnd);
}

function collapseSmooth(el) {
    // Wenn height = auto ist: aktuelle Pixelhöhe fixieren
    el.style.transition = "none";
    el.style.overflow = "hidden";

    // Wichtig: echte aktuelle Höhe nehmen (nicht scrollHeight)
    const current = el.getBoundingClientRect().height;
    el.style.height = current + "px";

    // Reflow + im nächsten Frame animieren
    el.offsetHeight;
    requestAnimationFrame(() => {
        el.style.transition = "height 300ms ease";
        el.style.height = "0px";
    });

    const onEnd = (e) => {
        if (e.propertyName !== "height") return;
        el.removeEventListener("transitionend", onEnd);
    };
    el.addEventListener("transitionend", onEnd);
}

function splideSliders() {
    initHeaderSlider();
    initGallerySlider();
}

function initHeaderSlider() {
    if (document.querySelector('.splide[data-slider="header"]')) {
        document.querySelectorAll('.splide[data-slider="header"]').forEach(function (el) {
            new Splide(el, {
                type: 'loop',
                autoplay: true,
                interval: 5000,
                speed: 1200,
                arrows: false,
                pagination: false,
                pauseOnHover: false,
                pauseOnFocus: false,
                drag: true,
                rewind: true,
            }).mount();
        });
    }
}

function initGallerySlider() {
    if (document.querySelector('.splide[data-slider="gallery"]')) {
        document.querySelectorAll('.splide[data-slider="gallery"]').forEach(function (el) {
            new Splide(el, {
                type: 'loop',
                perPage: 4.5,
                perMove: 1,
                autoplay: true,
                focus: 'center',
                interval: 5000,
                speed: 1200,
                arrows: true,
                pagination: true,
                pauseOnHover: false,
                pauseOnFocus: false,
                lazyLoad: true,
                preloadPages: 1,
                keyboard: true,
                drag: true,
                gap: '1rem',
                breakpoints: {
                    1200: {
                        perPage: 3.5,
                        gap: '1rem',
                    },
                    992: {
                        perPage: 2.5,
                        gap: '1rem',
                    },
                    640: {
                        perPage: 1.5,
                        gap: '1rem',
                    }
                }
            }).mount();
        });
    }
}





document.querySelectorAll("p").forEach(p => {
  if (p.textContent.trim() === "") {
    p.classList.add('is-empty');
  }
});